import { useString as s } from "../../../../components/StringProvider";

const ToText = () => {
  const to = s("discovery.kpi.card.impact.range", "to");

  return <>&nbsp;{to}&nbsp;</>;
};

export default ToText;
